import { render } from "./AuthLayout.vue?vue&type=template&id=5dd0871e&scoped=true&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import "./AuthLayout.vue?vue&type=style&index=0&id=5dd0871e&lang=scss&scoped=true"
import "./AuthLayout.vue?vue&type=style&index=1&id=5dd0871e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd0871e"]])

export default __exports__